import { decimalToUnits, MoneyError } from './money.js';
/** Provider-converted allowances may have sub-minor-unit fractions. Round down,
 * never enlarging an allowance; payment amounts still reject precision loss. */
export function providerAllowanceUnits(limit, remaining, decimals, maximum) {
    decimalToUnits('0', decimals, maximum);
    const precision = Math.max(decimals, limit.split('.')[1]?.length ?? 0, remaining.split('.')[1]?.length ?? 0);
    const originalLimit = decimalToUnits(limit, precision);
    const originalRemaining = decimalToUnits(remaining, precision);
    const scale = 10n ** BigInt(precision - decimals);
    const upper = maximum * scale + scale - 1n;
    if (originalLimit > upper || originalRemaining > upper)
        throw new MoneyError('overflow');
    if (originalRemaining > originalLimit)
        throw new Error('onramp_invalid_provider_limit');
    return { limit: originalLimit / scale, remaining: originalRemaining / scale };
}
